module.exports = __webpack_public_path__ + "static/media/MW-Logo-No-BG.85fcae2d.svg";